import RsaPlanning from "../index.js";

const routes = [
    {
        name: "RsaPlanningAll",
        path: "/rsaplanning",
        component: RsaPlanning.RsaPlanningPage,
        meta: { title: " Planning generale" },
    },
];

export default routes;
